import { DataversionInvalidError, ServiceError } from '../error-handling';
// see NGWIHDCC-2631
const VICCI_DATAVERSION_INVALID_CODES = [
    1004002,
    3004301,
    //          3004303 error code comes first for the other endpoints
    3004302,
    3004303,
    4004302, // The given Tenant Data Version String is not valid
];
// changed the return type to Error instead of throwing the exceptions.
// Reason is that callees had to return <R | undefined> because TS
// is unable to recognise that this function will always throw an exception
async function handleVicciDataversionUpdate(error) {
    if (error instanceof ServiceError && error.status === 400 && error.response) {
        try {
            const json = await error.response.json();
            if (json && VICCI_DATAVERSION_INVALID_CODES.indexOf(json.code) !== -1) {
                return new DataversionInvalidError(error.status, error.service, error.message);
            }
        }
        catch (e) {
            // This can't be a Dataversion invalid error, since it doesn't contain a proper JSON structure
            // just return the error as is
        }
    }
    return error;
}
export async function vicciPostDataversionUpdateHandler(callApi, url, service, body, options) {
    try {
        return await callApi(url, service, body, options);
    }
    catch (error) {
        throw await handleVicciDataversionUpdate(error);
    }
}
export async function vicciGetDataversionUpdateHandler(callApi, url, service, options) {
    try {
        return await callApi(url, service, options);
    }
    catch (error) {
        throw await handleVicciDataversionUpdate(error);
    }
}
